export default __webpack_public_path__ + "static/media/qr_code.a479734d.svg";